import { v4 as uuidv4 } from 'uuid';
import BriefAva from '@ui-kit/icons/brief.svg';
const BotsAva = '/images/botsAva.png';

export class MessageDTO {
  id;
  type;
  text;
  toId;
  edited;
  status;
  roomId;
  userId;
  fromId;
  isDeleted;
  createdAt;
  utcOffset;
  creatorId;
  projectId;
  recipientId;
  attachments;
  isMessagesSend;

  constructor(options) {
    let date = new Date();

    this.text = options.text;
    this.toId = options?.toId || null;
    this.type = options?.type || 'text';
    this.isRead = options?.isRead || 0;
    this.edited = options?.edited || 0;
    this.userId = options?.userId || null;
    this.roomId = options?.roomId || null;
    this.fromId = options?.fromId || null;
    this.isDeleted = options?.isDeleted || 0;
    this.projectId = options?.projectId || null;
    this.recipientId = options?.recipientId || {};
    this.status = options?.status ? +options.status : 0;
    this.createdAt = options?.createdAt || date.toISOString();
    this.utcOffset = -1 * (new Date(this.createdAt)).getTimezoneOffset();
    this.isMessagesSend = options?.isMessagesSend
      ? +options.isMessagesSend
      : true;
    this.creatorId = options?.creatorId || {
      id: uuidv4(),
      ava: options.messageType === 'bot' ? BotsAva : BriefAva,
    };
  }
}
